module.exports = "<pre><code class=\"hljs js\"><span class=hljs-comment>// with webpack you can import css</span>\n<span class=hljs-built_in>require</span>(<span class=hljs-string>'wovue-dialog/dist/dialog.css'</span>)\n\n<span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>\n<span class=hljs-keyword>import</span> Dialog <span class=hljs-keyword>from</span> <span class=hljs-string>'wovue-dialog'</span>\n\nVue.use(Dialog)\n</code></pre> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src-docs/app/snippets/installation-commonjs.md
 ** module id = 117
 ** module chunks = 1
 **/